/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  RoleDefinitionResolverV2,
  RoleDefinitionResolverV2Interface,
} from "../RoleDefinitionResolverV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "_ens",
        type: "address",
      },
      {
        internalType: "contract DomainNotifier",
        name: "_notifier",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
    ],
    name: "ABIChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "AddrChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newAddress",
        type: "bytes",
      },
    ],
    name: "AddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "AuthorisationChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "ContenthashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "record",
        type: "bytes",
      },
    ],
    name: "DNSRecordChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "DNSRecordDeleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "DNSZoneCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "lastzonehash",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "zonehash",
        type: "bytes",
      },
    ],
    name: "DNSZonehashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "InterfaceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newType",
        type: "uint8",
      },
    ],
    name: "IssuerTypeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "dids",
            type: "address[]",
          },
          {
            internalType: "bytes32",
            name: "role",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct IssuersResolver.Issuers",
        name: "newIssuers",
        type: "tuple",
      },
    ],
    name: "IssuersChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "roles",
            type: "bytes32[]",
          },
          {
            internalType: "bool",
            name: "mustHaveAll",
            type: "bool",
          },
        ],
        indexed: false,
        internalType:
          "struct EnrolmentPrerequisiteRolesResolver.PrerequisiteRoles",
        name: "newPrerequisiteRoles",
        type: "tuple",
      },
    ],
    name: "PrerequisiteRolesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "PubkeyChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newType",
        type: "uint8",
      },
    ],
    name: "RevokerTypeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "dids",
            type: "address[]",
          },
          {
            internalType: "bytes32",
            name: "role",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct RevokersResolver.Revokers",
        name: "newRevokers",
        type: "tuple",
      },
    ],
    name: "RevokersChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "string",
        name: "indexedKey",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "TextChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVersion",
        type: "uint256",
      },
    ],
    name: "VersionNumberChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentTypes",
        type: "uint256",
      },
    ],
    name: "ABI",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorisations",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "clearDNSZone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "contenthash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "dnsRecord",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "hasDNSRecords",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "interfaceImplementer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "issuerType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "issuerTypes",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "issuers",
    outputs: [
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "prerequisiteRoles",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "roles",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "mustHaveAll",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "pubkey",
    outputs: [
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "revokerType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "revokerTypes",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "revokers",
    outputs: [
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setABI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "a",
        type: "bytes",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "setAuthorisation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setContenthash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setDNSRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "setInterface",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
    ],
    name: "setIssuerDids",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "setIssuerRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "newIssuerType",
        type: "uint8",
      },
    ],
    name: "setIssuerType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32[]",
        name: "roles",
        type: "bytes32[]",
      },
      {
        internalType: "bool",
        name: "mustHaveAll",
        type: "bool",
      },
    ],
    name: "setPrerequisiteRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "setPubkey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "dids",
        type: "address[]",
      },
    ],
    name: "setRevokerDids",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "setRevokerRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "newRevokerType",
        type: "uint8",
      },
    ],
    name: "setRevokerType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    name: "setText",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "newVersionNumber",
        type: "uint256",
      },
    ],
    name: "setVersionNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setZonehash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "text",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "versionNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "versionNumbers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "zonehash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "domainUpdated",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

type RoleDefinitionResolverV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RoleDefinitionResolverV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RoleDefinitionResolverV2__factory extends ContractFactory {
  constructor(...args: RoleDefinitionResolverV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "RoleDefinitionResolverV2";
  }

  deploy(
    _ens: string,
    _notifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RoleDefinitionResolverV2> {
    return super.deploy(
      _ens,
      _notifier,
      overrides || {}
    ) as Promise<RoleDefinitionResolverV2>;
  }
  getDeployTransaction(
    _ens: string,
    _notifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_ens, _notifier, overrides || {});
  }
  attach(address: string): RoleDefinitionResolverV2 {
    return super.attach(address) as RoleDefinitionResolverV2;
  }
  connect(signer: Signer): RoleDefinitionResolverV2__factory {
    return super.connect(signer) as RoleDefinitionResolverV2__factory;
  }
  static readonly contractName: "RoleDefinitionResolverV2";
  public readonly contractName: "RoleDefinitionResolverV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RoleDefinitionResolverV2Interface {
    return new utils.Interface(_abi) as RoleDefinitionResolverV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RoleDefinitionResolverV2 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as RoleDefinitionResolverV2;
  }
}
